var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 0C4.02923 0 0 4.02966 0 9C0 13.9708 4.02923 18 9 18C13.9703 18 18 13.9708 18 9C18 4.02966 13.9703 0 9 0ZM13.0318 11.8772C13.326 12.171 13.326 12.6478 13.0318 12.942L12.9418 13.0325C12.6475 13.3263 12.1708 13.3263 11.8766 13.0325L9 10.155L6.12275 13.0323C5.82897 13.326 5.35224 13.326 5.05802 13.0323L4.96753 12.9418C4.67374 12.6475 4.67374 12.1708 4.96753 11.877L7.84499 9L4.96774 6.12319C4.67396 5.82897 4.67396 5.35224 4.96774 5.05802L5.05824 4.96796C5.35246 4.67374 5.82918 4.67374 6.12297 4.96796L9 7.84499L11.8768 4.96818C12.171 4.67396 12.6478 4.67396 12.942 4.96818L13.032 5.05824C13.3263 5.35246 13.3263 5.82918 13.032 6.1234L10.155 9L13.0318 11.8772Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.5ebaf0dae3ab228a2f801ae316b8f1ad.svg";
export { ForwardRef as ReactComponent };